var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b2b6f29988"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 160 L 530 160 L 530 743.488281 L 0 743.488281 Z M 0 160 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2b6f29988)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 239.605469 582.328125 C 185.027344 527.792969 162.878906 451.820312 173.953125 380.160156 L 255.785156 407.5 L 195.238281 160.941406 L 0 323.035156 L 85.285156 351.164062 C 63.929688 455.273438 93.769531 567.867188 173.953125 648.015625 C 270.3125 744.425781 411.832031 767.449219 529.476562 718.8125 L 507.328125 627.582031 C 420.390625 670.246094 312.089844 654.851562 239.605469 582.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 724.714844 482.539062 C 746.070312 378.503906 716.230469 265.910156 636.046875 185.6875 C 539.761719 89.28125 398.167969 66.257812 280.523438 114.894531 L 302.671875 206.121094 C 389.683594 163.53125 497.910156 178.855469 570.394531 251.375 C 624.972656 305.984375 647.121094 381.886719 636.046875 453.546875 L 554.214844 426.277344 L 614.761719 672.765625 L 810 510.671875 L 724.714844 482.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.33c2836f419549dd97317e1d59d01d16.svg";
export { ForwardRef as ReactComponent };